import React from 'react';
// import { useNavigate } from 'react-router-dom';
import {
    Container,
    Description,
    // DetailText,
    Icon,
    TextContainer,
    Title,
} from "./style-component";
import { CardBalanceProps } from './card-balance-types';
import FormattedImage from '@/components/formatted-image/formatted-image';
import brandData from "@/assets/brand.json"

const CardBalance: React.FC<CardBalanceProps> = ({ 
    amount, 
    // details, 
    symbol, 
    title,
    icon, 
    variant = 'default'
}) => {
    // const navigate = useNavigate();

    // const handleDetailsClick = () => {
    //     navigate('/wallet/history');
    // };

    return (
        <Container $variant={variant}>
            <Icon 
                as={FormattedImage}
                webpSrc={icon}
                fallbackSrc={brandData.pages.wallet.currencies[0].iconFallback}
                alt="Gema icon"
            />
            <TextContainer>
                <Title>{title}</Title>
                <Description>
                    {amount} {symbol}{amount !== 1 ? "s":""} 
                </Description>
                {/* <DetailText onClick={handleDetailsClick} style={{ cursor: 'pointer' }}>
                    {details}
                </DetailText> */}
            </TextContainer>
        </Container>
    );
};

export default CardBalance;
